import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const MemoRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-top: 0.25rem;
  padding: 0.5rem 0.75rem;
  border-radius: ${tokens.radius.chip};
  background: ${tokens.status.warning.bg};
  max-width: 34rem;
`

export const MemoHeadline = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 700;
  color: ${tokens.status.warning.fg};
`

export const MemoNote = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.secondary};
  line-height: 1.4;
`

export const ContinuityNote = styled.p`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
  font-variant-numeric: tabular-nums;
`

export const StatementCellText = styled.span<{ $em?: boolean }>`
  font-size: ${tokens.font.body};
  font-weight: ${({ $em }) => ($em ? 700 : 600)};
  color: ${({ $em }) => ($em ? tokens.text.primary : tokens.text.secondary)};
  font-variant-numeric: tabular-nums;
`

export const RechargeAmount = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 700;
  color: ${tokens.text.primary};
  font-variant-numeric: tabular-nums;
`
